import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "impx-features-tab uk-padding uk-padding-remove-top uk-padding-remove-horizontal uk-margin-medium-top uk-width-1-1" }
const _hoisted_2 = {
  class: "impx-ft-tab-items uk-position-top uk-margin-auto-left uk-margin-bottom",
  "data-uk-tab": ""
}
const _hoisted_3 = { href: "#" }
const _hoisted_4 = {
  id: "features-tab-content uk-margin-top",
  class: "uk-switcher impx-negative-top small uk-padding uk-padding-remove-bottom uk-margin-small-bottom uk-margin-large-top"
}
const _hoisted_5 = { class: "uk-grid" }
const _hoisted_6 = { class: "uk-width-1-3@xl uk-width-1-3@l uk-width-1-1@m" }
const _hoisted_7 = { class: "uk-margin-bottom" }
const _hoisted_8 = { class: "mobile-mb" }
const _hoisted_9 = { class: "uk-width-2-3@xl uk-width-2-3@l uk-width-1-1@m uk-width-1-1@s" }
const _hoisted_10 = { class: "uk-grid uk-grid-medium impx-margin-top impx-margin-top-m" }
const _hoisted_11 = ["src"]

import EventRoomOne from "@/views/event-activities/components/EventRoomOne.vue";
// import EventRoomTwo from "@/views/event-activities/components/EventRoomTwo.vue";
// import EventRoomThree from "@/views/event-activities/components/EventRoomThree.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventBooking',
  props: {
      eventPresentation:[]
    },
  setup(__props) {

const props = __props;
console.log(props.eventPresentation)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.eventPresentation, (eventItem, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "uk-active uk-margin-small-bottom",
          key: index
        }, [
          _createElementVNode("a", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-home" }, null, -1)),
            _createTextVNode(_toDisplayString(eventItem?.title??''), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.eventPresentation, (eventItemContent, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "tab-item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(eventItemContent?.subtitle??''), 1),
              _createElementVNode("p", null, _toDisplayString(eventItemContent?.description??''), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(eventItemContent?.description??''), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventItemContent.eventImages??[], (imgEventItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s mobile-mb impx-margin-bottom-medium",
                    key: index
                  }, [
                    _createElementVNode("img", {
                      src: imgEventItem?.url??'',
                      alt: "{{imgEventItem.name}}"
                    }, null, 8, _hoisted_11)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(EventRoomOne)
  ]))
}
}

})